export const LIST_DRAW_STATUS = 'LIST_DRAW_STATUS';


